import { PendingModelData } from 'src/store/state/projects';

const CLASSES_MAX_LIMIT = 200;
const PROPERTIES_MAX_LIMIT = 400;

export const checkImportModelLimits = (
  modelData: Record<string, PendingModelData>
): boolean => {
  const totalClasses = Object.values(modelData).reduce((total, data) => {
    return total + (data.classes ? Object.keys(data.classes).length : 0);
  }, 0);

  const totalProperties = Object.values(modelData).reduce((total, data) => {
    return total + (data.properties ? Object.keys(data.properties).length : 0);
  }, 0);

  const isClassesOverLimit = totalClasses > CLASSES_MAX_LIMIT;
  const isPropertiesOverLimit = totalProperties > PROPERTIES_MAX_LIMIT;

  return isClassesOverLimit || isPropertiesOverLimit;
};
